import React, { PureComponent } from "react";
import TeamEdit from "../components/team-edit";
import TeamNew from "../components/team-new";
import { getRequest } from "../../api/ApiService";
import { teamsEndpoint } from "../../api/Teams";
import _ from "lodash";

const STUDENT_ROLE = 1;

class TeamManagement extends PureComponent {
  constructor(props) {
    super(props);

    const { location } = props;
    const pathes = location.pathname.split("/").filter(i => i !== "");
    let game_id = parseInt(pathes[2], 10);
    if (isNaN(game_id)) {
      game_id = 0;
    }

    this.state = {
      game_id: game_id,
      course_id: 0,
      is_loaded: false,
      players: [],
      teams: [],
      free_users: [],
      showSuccessMessage: false
    };
  }

  componentDidMount() {
    this.fetchGame();
  }

  fetchData = () => {
    const { course_id } = this.state;
    const requests = [];
    requests.push(
      getRequest(
        `${process.env.REACT_APP_API_URL}courses/${course_id}/members/`
      )
    );
    requests.push(getRequest(`${process.env.REACT_APP_API_URL}team/players/`));
    requests.push(getRequest(`${process.env.REACT_APP_API_URL}users/`));
    requests.push(getRequest(teamsEndpoint()));
    const joinRequest = Promise.all(requests);

    joinRequest
      .then(res => {
        const course_members = res[0].body
          .filter(i => i.type === STUDENT_ROLE)
          .map(i => i.user);
        const players = _.orderBy(
          res[1].body.filter(i => i.user && course_members.includes(i.user.id)),
          player => player.user.username.toLowerCase(),
          ["asc"]
        );
        const team_users = players.map(i => i.user.id);
        const free_users = course_members.filter(i => !team_users.includes(i));
        const users = res[2].body.filter(i => free_users.includes(i.id));
        const teams = res[3].body.filter(i => i.course === course_id);

        this.setState({
          players,
          free_users: users,
          teams,
          is_loaded: true
        });
      })
      .catch(err => {});
  };

  fetchGame = () => {
    const { game_id } = this.state;

    getRequest(`${process.env.REACT_APP_API_URL}games/${game_id}/`)
      .then(res => {
        const { course } = res.body;

        this.setState(
          {
            course_id: course
          },
          () => {
            this.fetchData();
          }
        );
      })
      .catch(err => {});
  };

  updatedSuccessfully = () => {
    this.setState(
      {
        showSuccessMessage: true
      },
      () => {
        setTimeout(() => {
          this.setState({
            showSuccessMessage: false
          });
        }, 5000);
      }
    );
  };

  render() {
    const {
      is_loaded,
      players,
      teams,
      free_users,
      game_id,
      showSuccessMessage
    } = this.state;

    return (
      <section className="instructorPage">
        <h1>Team Management</h1>
        <div className="instructorWrapper">
          {showSuccessMessage === true && (
            <div className="row" style={{ margin: 0 }}>
              <div className="col-md-12" style={{ padding: 0 }}>
                <div className="alert alert-success">Updated successfully!</div>
              </div>
            </div>
          )}
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th className="text-center instructor-table-th">No.</th>
                  <th className="text-center instructor-table-th">Name</th>
                  <th className="text-center instructor-table-th">Team</th>
                  <th className="text-center instructor-table-th">Role</th>
                  <th className="text-center instructor-table-th"></th>
                </tr>
              </thead>
              <tbody>
                {is_loaded === false && (
                  <tr>
                    <td
                      colSpan={5}
                      className="text-center v-align-middle instructor-td"
                    >
                      Loading...
                    </td>
                  </tr>
                )}
                <TeamNew
                  teams={teams}
                  counter={1}
                  free_users={free_users}
                  fetchData={this.fetchGame}
                  game_id={game_id}
                />
                {is_loaded === true &&
                  players.map((player, index) => (
                    <TeamEdit
                      key={index}
                      player={player}
                      counter={index + 2}
                      teams={teams}
                      fetchData={this.fetchData}
                      game_id={game_id}
                      updatedSuccessfully={this.updatedSuccessfully}
                    />
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    );
  }
}

export default TeamManagement;



// WEBPACK FOOTER //
// ./src/instructor/containers/team-management.js